import styled from 'styled-components'

export const Preview = styled.div`
  margin-bottom: 20px;
  word-break: break-word;

  & * > ul,
  ol {
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  & * > li {
    list-style: inherit;
  }

  & * > img {
    max-width: 100%;
  }

  & * > a {
    color: var(--t-link-color);
    word-break: break-word;

    &:hover {
      var(--t-link-hover);
  }

  code {
    word-break: break-word;
    white-space: pre-wrap;
    font-family: inherit;
    letter-spacing: 0;
  }

  & > div > p {
    word-break: break-word;
  }

  & * > p {
    min-height: 1em;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  & > * blockquote {
    font-style: italic;
    border-left: 3px solid var(--p-neutral-370);
    padding-left: 0.6em;
    margin-left: 0;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  pre {
    word-break: break-word;
  }
`
